import React, { useState } from 'react';
import { useQuery, useMutation } from 'react-query';
import { endpoints, fetcher } from 'services';
import { useLocation } from 'react-router-dom';
import qs from 'query-string';

const useManagement = (target: string) => {
  /* ======================================================
   * state
   * ====================================================== */
  const [salesList, setSalesList] = useState<any[]>();
  const [detailList, setDetailList] = useState<any[]>();
  const [codeList, setCodeList] = useState<any[]>();

  /* ======================================================
   * hooks
   * ====================================================== */
  const location = useLocation();

  const searchParams = qs.parse(location.search);
  const today = new Date();
  const default_start_date = today.getFullYear().toString() + '-01';
  const default_end_date = today.getFullYear().toString() + '-12';

  const { isLoading, refetch } = useQuery(
    [endpoints.management.sales, [location.search, target]],
    () =>
      fetcher.management.postSales({
        searchDateStart: searchParams.searchDateStart ? String(searchParams.searchDateStart) : default_start_date,   
        searchDateEnd: searchParams.searchDateEnd ? String(searchParams.searchDateEnd) : default_end_date,          
        target: target, 
      }),
    {
      onSuccess: (res: ManagementListResDto) => {
        switch (res.code) {
          case 200:
            setSalesList(res.result?.list);
            setCodeList(res.result?.code);
            break;
          case 400:
          default:
            break;
        }
      },
    },
  );

  const { mutate: salesDetail } = useMutation(
    [endpoints.management.salesDetail],
    fetcher.management.postSalesDetail,
    {
      onSuccess: (res) => {
        switch (res.code) {
          case 200:
            setDetailList(res.result?.list);
            break;
          default:
            break;
        }
      },
    },
  )

  return { salesList, codeList, detailList, refetch, salesDetail };
};

export default useManagement;
